type ViewTransitionResult = {
  finished?: Promise<void>;
  ready?: Promise<void>;
  updateCallbackDone?: Promise<void>;
};

type ViewTransitionCapableDocument = Document & {
  startViewTransition?: (update: () => void | Promise<void>) => ViewTransitionResult;
};

const swallowSkippedTransitionError = (error: unknown) => {
  if ((error as { name?: string } | null | undefined)?.name === 'AbortError') {
    return;
  }

  console.error('View transition failed.', error);
};

export const runViewTransition = (update: () => void | Promise<void>) => {
  const transitionDocument = document as ViewTransitionCapableDocument;

  if (typeof transitionDocument.startViewTransition !== 'function') {
    void Promise.resolve().then(update).catch((error) => {
      console.error('Navigation update failed.', error);
    });
    return;
  }

  const transition = transitionDocument.startViewTransition(update);
  transition?.ready?.catch(swallowSkippedTransitionError);
  transition?.finished?.catch(swallowSkippedTransitionError);
  transition?.updateCallbackDone?.catch(swallowSkippedTransitionError);
};
